import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from './Icon';
import parsePhoneNumberFromString from 'libphonenumber-js';
import './Phone.scss';
/**
 * @component Phone
 * @since 1.0.0
 */
export function Phone(props) {
    const { style, value, icon, isLink } = Object.assign({ isLink: false, style: 'normal' }, props);
    if (value == null || value == '') {
        return null;
    }
    const className = classNames('phone', 'phone--' + style, props.className);
    return isLink ? (React.createElement("a", { className: className, href: 'tel:' + value },
        icon && React.createElement(Icon, { value: "phone" }),
        formatPhone(value))) : (React.createElement("span", { className: className },
        icon && React.createElement(Icon, { value: "phone" }),
        formatPhone(value)));
}
/**
 * @function formatPhone
 * @since 1.0.0
 */
export function formatPhone(value) {
    const phoneNumber = parsePhoneNumberFromString(value);
    return phoneNumber ? phoneNumber.formatNational() : value;
}
